/**
 * Centralised environment configuration for the admin dashboard.
 *
 * Create React App only exposes variables prefixed with `REACT_APP_` to the
 * browser bundle. Values are read once at build time (`npm run build`) or
 * when the dev server starts (`npm start`), then inlined into the JS output.
 *
 * Local dev: edit `.env.development` (loaded by `npm start`).
 * Production: edit `.env.production` or set `REACT_APP_*` in CI/CD before `npm run build`.
 */

const readEnv = (key: string, fallback = ''): string => {
  const value = process.env[key];
  if (value !== undefined && value !== '') {
    return value;
  }
  return fallback;
};

export const ENV = {
  /** AES key shared with the admin backend for encrypting request payloads. */
  REQ_ENC_KEY: readEnv('REACT_APP_REQ_ENC_KEY'),

  API_BASE_URL: readEnv('REACT_APP_API_BASE_URL', 'http://localhost:8006'),
  SENTIMENT_API_BASE_URL: readEnv(
    'REACT_APP_SENTIMENT_API_BASE_URL',
    'https://iip.thesampark.com'
  ),

  /** Secret for encrypting the redux-persist blob in localStorage. */
  PERSIST_SECRET: readEnv(
    'REACT_APP_PERSIST_SECRET',
    'sampark-admin-persist-secret'
  ),

  RAZORPAY_KEY_ID: readEnv('REACT_APP_RAZORPAY_KEY_ID'),
  RAZORPAY_KEY_SECRET: readEnv('REACT_APP_RAZORPAY_KEY_SECRET'),

  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
} as const;

const PRODUCTION_REQUIRED: Array<keyof typeof ENV> = [
  'REQ_ENC_KEY',
  'API_BASE_URL',
  'PERSIST_SECRET',
];

/**
 * Validates that required env vars are present. In production, missing values
 * throw so a misconfigured build fails fast instead of silently at runtime.
 */
export function validateEnv(): void {
  const missing = PRODUCTION_REQUIRED.filter((name) => !ENV[name]);

  if (missing.length === 0) {
    return;
  }

  const envKeys = missing.map((name) => `REACT_APP_${name}`);
  const message = `Missing required environment variable(s): ${envKeys.join(', ')}`;

  if (ENV.IS_PRODUCTION) {
    throw new Error(message);
  }

  console.warn(`[env] ${message}. Using development fallbacks where available.`);
}
